import React from 'react';
import { useSelector } from 'react-redux';
import { useD3 } from '../../hooks/useD3';
import d3 from '../../utils/d3Importer';
import { numberWithCommas } from '../../utils/functions';

export default function Chart(props) {
  const { religion, values } = props;

  const stageWidth = useSelector((state) => state.browserUtils.width);
  console.log('stageWidth ', stageWidth);

  const margin = { top: 32, right: 50, bottom: 40, left: 50 };
  const width = stageWidth < 480 ? stageWidth : stageWidth * 0.5;
  const height = width * 0.7;

  const colour = '#2845b2';

  const ref = useD3(
    (svg) => {
      const chartWidth = width - margin.left - margin.right;
      const chartHeight = height - margin.top - margin.bottom;

      const x = d3
        .scaleBand()
        .domain(values.map((obj) => obj.year))
        .padding(0.1)
        .range([0, chartWidth]);

      const y = d3.scaleLinear().range([chartHeight, 0]).domain([0, 850000]);

      const line = d3
        .line()
        .curve(d3.curveMonotoneX)
        .defined((d) => d.value !== null)
        .x((d) => {
          return x(d.year) + x.bandwidth() * 0.5;
        })
        .y((d) => {
          return y(d.value);
        });

      const xAxis = (g) => {
        g.attr('transform', `translate(0,${chartHeight})`)
          .call(d3.axisBottom(x).ticks(4))
          .call(() => g.select('.domain').remove());
      };

      const yAxis = (g) => {
        g.call(d3.axisLeft(y).ticks(4).tickSize(-chartWidth))
          .call(() => g.select('.domain').remove())
          .call(() =>
            g.selectAll('line').attr('stroke-dasharray', (d, i) => {
              return i === 0 ? 'none' : '2,4';
            }),
          );
      };

      // clear on resize
      svg.select('.line-chart').html('');
      svg.select('.x-axis').html('');
      svg.select('.y-axis').html('');
      svg.select('.latest').html('');

      svg
        .select('.chart')
        .attr('transform', `translate(${margin.left},${margin.top})`);

      svg.select('.x-axis').call(xAxis);
      svg.select('.y-axis').call(yAxis);

      svg
        .select('.line-chart')
        .append('path')
        .attr('d', () => {
          return line(values);
        })
        .style('fill', 'none')
        .style('stroke-width', '3px')
        .style('stroke-linecap', 'round')
        .style('stroke', colour);

      svg
        .select('.dots-chart')
        .selectAll('.dot')
        .data(values)
        .join('circle')
        .attr('class', (d, i) => {
          return `dot dot${i}`;
        })
        .attr('r', (d) => {
          return d.value !== null ? 4 : 0;
        })
        .attr('cx', (d) => {
          return x(d.year) + x.bandwidth() * 0.5;
        })
        .attr('cy', (d) => {
          return y(d.value);
        })
        .style('fill', colour);

      svg
        .select('.latest')
        .append('text')
        .text(() => {
          return numberWithCommas(values[values.length - 1].value);
        })
        .attr('x', () => {
          return x(values[values.length - 1].year) + x.bandwidth() * 0.5;
        })
        .attr('y', () => {
          return y(values[values.length - 1].value);
        })
        .attr('dy', -26)
        .style('font-size', 14)
        .style('fill', colour)
        .style('font-weight', 700)
        .style('text-anchor', 'middle')
        .style('font-family', 'Raleway');

      svg
        .select('.latest')
        .append('text')
        .text('people')
        .attr('x', () => {
          return x(values[values.length - 1].year) + x.bandwidth() * 0.5;
        })
        .attr('y', () => {
          return y(values[values.length - 1].value);
        })
        .attr('dy', -12)
        .style('font-size', 14)
        .style('fill', colour)
        .style('font-weight', 700)
        .style('text-anchor', 'middle')
        .style('font-family', 'Raleway');
    },
    [stageWidth],
  );

  const style = {
    marginRight: '0px',
    marginLeft: '0px',
    width,
    height,
  };

  return (
    <div className="chart-wrap">
      <h4>{religion}</h4>
      <svg ref={ref} style={style}>
        <g className="chart">
          <g className="line-chart" />
          <g className="dots-chart" />
          <g className="x-axis" />
          <g className="y-axis" />
          <g className="latest" />
        </g>
      </svg>
    </div>
  );
}
